import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { ConsentTypeContactDanish } from '../../helpers/EnumsDanish';
import { PhoneNumberSpacing } from '../../helpers/TextCheckers';


type HeaderProps = {
    advertisersWithConsents: any
}


function OwnerConsentsPdf(props: HeaderProps) {
    let { advertisersWithConsents } = props;

    const styles = StyleSheet.create({
        page: {
            backgroundColor: '#ffffff',
            color: '000000',
            fontSize: '12',
            fontWeight: 'normal'
        },
        header: {
            backgroundColor: '#effaf9',
            marginBottom: '12px',
            textAlign: 'center',
            color: '#002f38',
            fontSize: '16'
        },
        headline: {
            margin: '16px 0',
            fontSize: '20'
        },
        subheader: {
            marginBottom: '10px',
            color: '#004000'
        },
        pageheader: {
            marginBottom: '10px',
            color: '#004000',
            fontSize: '18'
        },
        pagesubheader: {
            marginTop: '4px',
            marginBottom: '8px',
            color: '#000040',
            fontSize: '16'
        },
        section: {
            borderWidth: 1,
            borderColor: '#c0c0f0',
            margin: '4px 8px 12px 8px',
            padding: '0',
            borderRadius: 6
        },
        key: {
            marginTop: '10px',
            marginBottom: '4px',
            fontWeight: 'bold'
        },
        capitalize: {
            textTransform: 'capitalize'
        },
        advertiserHeader: {
            backgroundColor: '#add8e6',
            color: '#000000',
            margin: '.4em 6px',
            padding: '4px 50px 4px 10px',
            borderRadius: 6
        },
        consentBox: {
            margin: '4px 12px',
            backgroundColor: '#f5f5f5',
            fontSize: '10',
            padding: '8px',
            lineHeight: '1.4',
            borderRadius: 4
        }
    });


    return (
        <Document>
            <Page size="A4" style={styles.page}>
                { advertisersWithConsents !== null ?
                    <>
                        <View style={styles.header}>
                            <Text style={styles.headline}>Mitsamtykke.dk - dine samtykker</Text>
                            <Text style={styles.subheader}>{advertisersWithConsents[0].consents[0].firstname} {advertisersWithConsents[0].consents[0].lastname}</Text>
                        </View>
                        <View>
                            { advertisersWithConsents.map((adv: any, index: number) => (
                                <View key={index} style={styles.section}>
                                    <Text style={styles.advertiserHeader}>{ adv.stakeholderName }</Text>
                                    { adv !== null && adv.consents.map((consent: any, indexInner: number) => (
                                        <View key={indexInner} style={styles.consentBox}>
                                            <Text>Status: {consent.isRevoked ?  'Tilbagekaldt' : 'Aktiv'}</Text>
                                            <Text>Kampagne: {consent.campaignTitle}</Text>
                                            <Text>Fornavn: {consent.firstname}</Text>
                                            <Text>Efternavn: {consent.lastname}</Text>
                                            <Text>Mobiltelefon: {PhoneNumberSpacing(consent.mobilePhone)}</Text>
                                            <Text>Emailaddresse: {consent.email}</Text>
                                            <Text>Fastnettelefon: {PhoneNumberSpacing(consent.phone)}</Text>
                                            <Text>Adresse: {consent.address}</Text>
                                            <Text>Postnr.: {consent.postalCode}</Text>
                                            <Text>By: {consent.city}</Text>
                                            <Text>F&oslash;dselsdato: {consent.dateOfBirth}</Text>
                                            <Text>K&oslash;n: { consent.gender === '0' ? 'Mand' : 'Kvinde'}</Text>
                                            <Text>Fra IP-Adresse: {consent.signupIP}</Text>
                                            <Text>Webside: {consent.signupURL}</Text>
                                            <Text>Oprettet: {consent.consentDateTime}</Text>
                                            { consent.consentAuxiliaryFieldTypes !== null && Object.keys(consent.consentAuxiliaryFieldTypes).length > 0 &&
                                                Object.keys(consent.consentAuxiliaryFieldTypes).map((auxField: any, index: number) => (
                                                    <Text key={index} style={styles.capitalize}>{auxField}: {consent.consentAuxiliaryFieldTypes[auxField]}</Text>
                                                ))
                                            }
                                            { consent.consentTypes !== null && Object.keys(consent.consentTypes).length > 0 &&
                                                <Text>Type: { consent.consentTypes.map((ct: number, index: number) => (
                                                    <Text key={index}>{ ConsentTypeContactDanish[ct] }&nbsp;</Text>
                                                ))}</Text>
                                            }
                                        </View>
                                    ))
                                }
                                </View>
                            ))
                            }
                        </View>
                    </>
                :
                    "En fejl opstod ved generering af PDF dokument"
                }
            </Page>
        </Document>
    );
}

export default OwnerConsentsPdf;